import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import styles from './guest-groups-list.scss'
import moment from 'moment'
import cn from 'classnames'

class GuestGroupsList extends Component {
  filterHostGroup = () => {
    const { guestsList, event } = this.props
    const host = guestsList.filter(item => item.guest === event.host)

    return host
  }

  filterCohostGroup = () => {
    const { guestsList } = this.props
    const cohost = guestsList.filter(item => item.cohost)

    return cohost
  }

  filterGuestsGroup = () => {
    const { guestsList, event } = this.props
    const guests = guestsList.filter(item => !item.cohost && item.guest !== event.host)

    return guests
  }

  renderStatusText = guest => {
    const { guest_count, child_count, rsvp_state, delivery_state, viewed_at, delivered_at } = guest

    if (rsvp_state === 'accepted') {
      return (
        <div className={styles['accepted-text']}>
          <div className={styles['text']}>Yes</div>
          <div className={styles['guest-text']}>
            {guest_count > 0 && (
              <div className={styles['guest-count']}>
                {guest_count} Adult{guest_count > 1 ? 's' : ''}
              </div>
            )}
            {child_count > 0 && (
              <div className={styles['child-count']}>
                {child_count} {child_count > 1 ? 'Children' : 'Child'}
              </div>
            )}
          </div>
        </div>
      )
    } else if (rsvp_state === 'declined') {
      return <div className={styles['declined-text']}>No</div>
    } else if (rsvp_state === 'undecided' && delivery_state === 'delivered') {
      return (
        <div className={styles['delivered-text']}>
          <div className={styles['text']}>Delivered</div>
          <div className={styles['time']}>{moment(delivered_at).format('MM.DD.YYYY')}</div>
        </div>
      )
    } else if (rsvp_state === 'undecided' && delivery_state === 'viewed') {
      return (
        <div className={styles['delivered-text']}>
          <div className={styles['text']}>Viewed</div>
          <div className={styles['time']}>{moment(viewed_at).format('MM.DD.YYYY')}</div>
        </div>
      )
    } else if (delivery_state === 'delivery_failed' || delivery_state === 'delivery_aborted') {
      return <div className={styles['declined-text']}>Failed</div>
    } else if (delivery_state === 'queued') {
      return (
        <div className={styles['delivered-text']}>
          <div className={styles['text']}>Sending</div>
        </div>
      )
    } else if (delivery_state === 'pending') {
      return (
        <div className={styles['delivered-text']}>
          <div className={styles['unsent']}>Unsent</div>
        </div>
      )
    }
  }

  renderGroup = (title, list) => {
    if (list.length === 0) return null

    const { onClickGuest, onGetUser } = this.props
    const isHost = title === 'host'

    return (
      <div className={styles['group-wrapper']}>
        <div className={styles['group-title']}>{title}</div>
        <ul className={styles['group-content']}>
          {list.map(item => {
            const user = onGetUser(item)
            const sendFailed =
              item.delivery_state === 'delivery_failed' ||
              item.delivery_state === 'delivery_aborted'

            return (
              <li
                className={cn(styles['list-item'], { [styles['list-item-failed']]: sendFailed })}
                key={item.id}
                onClick={() => onClickGuest(item)}
              >
                <UserAvatarContainer user={user} url={item.avatar_url} size={34} />
                <div className={styles['info-wrapper']}>
                  <span className={styles['name']}>{user.displayName}</span>
                  <span className={styles['contact-text']}>
                    {isHost ? 'Event Host' : item.contact_method_display_name}
                  </span>
                </div>

                {!isHost && (
                  <div className={styles['status-wrapper']}>{this.renderStatusText(item)}</div>
                )}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }

  render() {
    const host = this.filterHostGroup()
    const cohost = this.filterCohostGroup()
    const guests = this.filterGuestsGroup()
    return (
      <div className={styles['guest-groups-list-container']}>
        {this.renderGroup('host', host)}
        {this.renderGroup('co-hosts', cohost)}
        {this.renderGroup('guests', guests)}
      </div>
    )
  }
}

GuestGroupsList.propTypes = {
  event: PropTypes.object,
  guestsList: PropTypes.array,
  onClickGuest: PropTypes.func,
  onGetUser: PropTypes.func
}

export default GuestGroupsList
